import { render, staticRenderFns } from "./client-school-form.vue?vue&type=template&id=ca6e3644"
import script from "./client-school-form.vue?vue&type=script&lang=js"
export * from "./client-school-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports